import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-awaiting-signer-acknowledgement',
  templateUrl: './awaiting-signer-acknowledgement.component.html',
  styleUrls: ['./awaiting-signer-acknowledgement.component.scss'],
  standalone: false,
})
export class AwaitingSignerAcknowledgementComponent {
  static identifier = 'AwaitingSignerAcknowledgementComponent';

  // TEMP: dev-only signal so the notary can proceed locally without the
  // cross-browser SignalR broadcast. Remove once real ack propagation lands.
  @Output() devMarkAcknowledged = new EventEmitter<void>();
}
